import Pagination from '@/mixins/paging';

export default {
	mixins: [Pagination],
	data() {
		return {
			scrollLock: false
		};
	},
	computed: {
		page: {
			get() {
				return this.pagingModel.page;
			},
			set(value) {
				this.pagingModel.page = value;
			}
		}
	},
	methods: {
		setPagingData(data, overrride, commitName) {
			if (overrride) {
				this.pagingModel.items = data.items;
				this.pagingModel.countPerPage = data.items.length;
			} else {
				this.pagingModel.items = [
					...this.pagingModel.items,
					...data.items
				];
				this.pagingModel.countPerPage += data.items.length;
			}

			this.pagingModel.totalCount = data.totalCount;
			this.pagingModel.totalPageCount = data.totalPageCount;
			this.pagingModel.page = data.page;

			if (commitName) {
				this.$store.dispatch(commitName, { ...this.pagingModel });
			}

			this.scrollLock = false;
		}
	},
	watch: {
		scrollLock: {
			handler(val) {
				if (val && this.nextPage != undefined) {
					this.page = this.nextPage;
				}
			}
		}
	}
};
